import { useCallback } from 'react';
import type { ReviewResource } from '@studio/shared';
import { api } from '../../shell/api.js';
import { useAsync, type Loaded } from '../../shell/useAsync.js';
import { useResourceEvents } from '../../shell/stream.js';

/**
 * One read for all three stages.
 *
 * Contact sheet, Play stage and Packing desk are a sequence, not a set of modes, so
 * they share the resource rather than each asking for a slice of it. The stream is the
 * shell's single EventSource: a Technical Check, a Play Test Pair slot or a finished
 * Export Package arriving from a worker refreshes what is on screen.
 */
const WATCHED = new Set(['technicalCheck', 'playTestPair', 'exportPackage', 'candidate', 'experiment']);

export function useReview(experimentId: string): Loaded<ReviewResource> {
  const loaded = useAsync(() => api.readReview(experimentId), [experimentId]);
  const reload = loaded.reload;

  useResourceEvents(
    useCallback(
      (event: { resource: string }) => {
        if (WATCHED.has(event.resource)) reload();
      },
      [reload],
    ),
  );

  return loaded;
}
